import React from 'react';
import {ReactComponent as Icon} from 'images/icon/trash.svg';
import classNames from 'classnames';

export default class TrashIcon extends React.PureComponent {
  render() {
    return <Icon {...this.props} className={classNames('icon trash', this.props.className)} />;
  }
}
